export const toggleShowLevel2Modifier = ($nav, $subNav, toggle = undefined) =>
    $nav.toggleClass(
        'navigation--level-2-opened',
        typeof toggle !== 'undefined'
            ? toggle
            : !$subNav.hasClass('navigation-level-2--opened')
    );
